import { decryptStripeKey } from './decryption'

const getCookie = (cname) => {
	const name = cname + '='
	const decodedCookie = decodeURIComponent(document.cookie)
	const ca = decodedCookie.split(';')
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i]
		while (c.charAt(0) === ' ') {
			c = c.substring(1)
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length)
		}
	}
	return ''
}

export const parseGaSessionIdFromCookie = (cookieVal) => {
	if (!cookieVal) {
		return null
	}
	if (cookieVal.startsWith('GS2.')) {
		const match = cookieVal.match(/\.s(\d+)/)
		return match ? match[1] : null
	}
	return cookieVal.split('.')[2] || null
}

export const getGaAttributionIds = () => {
	const result = {
		client_id: null,
		session_id: null,
		facebook_fbp: null,
		facebook_fbc: null,
	}

	if (typeof document === 'undefined') {
		return result
	}

	try {
		const measurementIdRaw = decryptStripeKey(
			typeof process !== 'undefined' ? process.env.REACT_APP_GA_MEASUREMENT_ID : undefined
		)
		const mesId = measurementIdRaw ? measurementIdRaw.split('-')[1] : null

		const gaCookie = getCookie('_ga')
		if (gaCookie) {
			const gaParts = gaCookie.split('.')
			if (gaParts.length >= 4) {
				result.client_id = `${gaParts[2]}.${gaParts[3]}`
			}
		}
		console.log("TRACK_GA mesId", mesId);
		if (mesId) {
			const sessionCookie = getCookie(`_ga_${mesId}`)
			console.log("TRACK_GA sessionCookie", sessionCookie);
			result.session_id = parseGaSessionIdFromCookie(sessionCookie)
			console.log("TRACK_GA result.session_id", result.session_id);
		}
		const fbp = getCookie('_fbp')
		const fbc = getCookie('_fbc')
		if (fbp) {
			result.facebook_fbp = fbp
		}
		if (fbc) {
			result.facebook_fbc = fbc
		}
	} catch (err) {
		console.warn('getGaAttributionIds: could not read GA cookies', err)
	}

	return result
}

/** Merge GA attribution fields onto a target object (mutates target). */
export const appendGaAttributionToPayload = (target) => {
	const ga = getGaAttributionIds()
	if (ga.client_id) {
		target.client_id = ga.client_id
	}
	if (ga.session_id) {
		target.session_id = ga.session_id
	}
	if (ga.facebook_fbp) {
		target.facebook_fbp = ga.facebook_fbp
	}
	if (ga.facebook_fbc) {
		target.facebook_fbc = ga.facebook_fbc
	}
	return target
}
